import React, { createContext } from 'react';
import axios from "axios";
import { HEADERS } from "../config";

export const UserContext = createContext();

class UserProvider extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            token: localStorage.getItem("token")
        }

        this.updateUserInfo = this.updateUserInfo.bind(this);
        this.logOutUser = this.logOutUser.bind(this);
    }


    updateUserInfo (userObj) {
        this.setState({token: userObj.token})
    }


    logOutUser(props) {
        axios.post(process.env.REACT_APP_API_ENDPOINT + "/v1/staff/logout", {}, HEADERS)
        .then((result) => {
            localStorage.clear();
            this.setState({token: ""});
            props.history.push("/");
        })
        .catch(err => console.log(err));
    }


    render () {
        return (
            <UserContext.Provider
                value={{
                    ...this.state,
                    updateUserInfo: this.updateUserInfo,
                    logOutUser: this.logOutUser,
                }}
            >
                {this.props.children}
            </UserContext.Provider>
        );
    }
}

export default UserProvider;
